// base imports
import { LanguageProvider } from '@web_opxp/features';
import { Provider } from 'react-redux';
import AppWrapper from './AppWrapper';
import * as Actions from './store/actions';
// redux store
import { SSO_AVAILABLE_LANGUAGES } from '../../core/constants';
import { IsDebug, LocalesBaseUrl } from '../../core/env';
import getStore from './store/store';

export default function LegalsApp() {
  // initialize store and start app
  const store = getStore();
  // start language feature
  store.dispatch(Actions.LegalsInitAction());
  return (
    <Provider store={store}>
      <LanguageProvider
        ns={['common.common', 'common.auth', 'opxp.common', 'opxp.prereg']}
        defaultNS="common.auth"
        fallbackNS="common.common"
        localesPath={LocalesBaseUrl}
        supportedLngs={SSO_AVAILABLE_LANGUAGES}
        debug={IsDebug}>
        <AppWrapper />
      </LanguageProvider>
    </Provider>
  );
}
